// @ts-nocheck
import React from 'react';
import classNames from 'classnames';
import styled from 'styled-components';
import { Card } from '@/components';
import { CLASSES } from '@/constants/classes';
import ShipMethodsList from './ShipMethodList';
//import '@/style/pages/Preferences/ShipMethods.scss';

export default function PreferencesShipMethodsPage() {
  return (
    <div
      className={classNames(
        CLASSES.PREFERENCES_PAGE_INSIDE_CONTENT,
        CLASSES.PREFERENCES_PAGE_INSIDE_CONTENT_SHIP_METHODS,
      )}
    >
      <ShipMethodsCard>
        <ShipMethodsList />
      </ShipMethodsCard>
    </div>
  );
}

const ShipMethodsCard = styled(Card)`
  padding: 0;
`;
